import { render, staticRenderFns } from "./AiSupportChat.vue?vue&type=template&id=21f47fb2&scoped=true"
import script from "./AiSupportChat.vue?vue&type=script&lang=js"
export * from "./AiSupportChat.vue?vue&type=script&lang=js"
import style0 from "./AiSupportChat.vue?vue&type=style&index=0&id=21f47fb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f47fb2",
  null
  
)

export default component.exports